import { render, staticRenderFns } from "./EditEventBaseForm.vue?vue&type=template&id=5e245cac&scoped=true&"
import script from "./EditEventBaseForm.vue?vue&type=script&lang=ts&"
export * from "./EditEventBaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditEventBaseForm.vue?vue&type=style&index=0&id=5e245cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e245cac",
  null
  
)

export default component.exports